module.exports = __webpack_public_path__ + "img/text-mark6.fb3e576c.png";